<template>

    <v-list-item avatar
          :to="{
    				name: 'Child',
    				params: { personId: child.personId }
    		    	}"
           >
      <v-list-item-avatar :color="randomColour">
        <img
          v-if="child.photoUrl"
          :src="child.photoUrl"
          :alt="`${childFullName} Avatar`"
        />


        <span v-else class="white--text subheading text-center">{{ childInitials }}</span>

      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>{{ childFullName }}</v-list-item-title>
        <v-list-item-subtitle>{{ childVitalDetails }}</v-list-item-subtitle>

      </v-list-item-content>


    </v-list-item>


</template>

<script>

import { PersonListItemWithAvatarMixin } from './../../../../../bookingservice/v4/components/Global/People/PersonListItemWithAvatarMixin';

export default {
  name: 'PersonListItemWithAvatarMinusParentDetails',

  mixins: [PersonListItemWithAvatarMixin]

};
</script>

<style scoped>

</style>
